import { ConfirmButton } from "@/components/common/ConfirmButton";
import { CopyIconButton } from "@/components/common/CopyIconButton";

interface EnvironmentOtherPanelProps {
	environmentId: string;
	/** 削除の確認ダイアログを開く。 */
	onDelete: () => void;
	/** 起動・停止などの操作中は削除できない。 */
	deleteDisabled: boolean;
	/** 削除の確認を開く前の確認の途中か。 */
	deleteLoading?: boolean;
}

/** 頻繁には使わない情報と操作をまとめるタブ。ID と削除を置く。 */
export function EnvironmentOtherPanel({
	environmentId,
	onDelete,
	deleteDisabled,
	deleteLoading = false,
}: EnvironmentOtherPanelProps) {
	return (
		<div
			data-testid="environment-other-panel"
			style={{
				flex: 1,
				minHeight: 0,
				overflowY: "auto",
				padding: "20px 24px",
				display: "flex",
				flexDirection: "column",
				gap: 16,
			}}
		>
			<dl
				style={{
					margin: 0,
					display: "grid",
					gridTemplateColumns: "auto minmax(0, 1fr)",
					columnGap: 16,
					alignItems: "center",
					fontSize: "var(--text-ui)",
				}}
			>
				<dt style={{ color: "var(--fg-3)", fontSize: "var(--text-caption)", fontWeight: 500 }}>
					ID
				</dt>
				<dd style={{ margin: 0, minWidth: 0, color: "var(--fg-1)" }}>
					<span style={{ display: "inline-flex", alignItems: "center", gap: 4, minWidth: 0 }}>
						<span style={{ fontFamily: "var(--font-mono)", fontSize: "var(--text-caption)" }}>
							{environmentId}
						</span>
						<CopyIconButton value={environmentId} label="ID をコピー" />
					</span>
				</dd>
			</dl>
			<section
				style={{
					display: "flex",
					alignItems: "center",
					gap: 16,
					padding: "14px 16px",
					borderRadius: "var(--radius-3)",
					boxShadow: "0 0 0 1px var(--danger-line)",
				}}
			>
				<div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 4 }}>
					<h4
						style={{ margin: 0, fontSize: "var(--text-ui)", fontWeight: 600, color: "var(--fg-1)" }}
					>
						エージェントを削除
					</h4>
					<p
						style={{
							margin: 0,
							fontSize: "var(--text-caption)",
							lineHeight: "var(--leading-body)",
							color: "var(--fg-2)",
						}}
					>
						稼働中の場合は停止され、
						<strong style={{ fontWeight: 600, color: "var(--fg-1)" }}>
							エージェント環境内のファイルはすべて削除されます
						</strong>
						。チャットはアーカイブに移動し、履歴の閲覧のみ可能になります。この操作は元に戻せません。共有ボリュームは影響を受けません。
					</p>
				</div>
				<ConfirmButton
					label="削除"
					loading={deleteLoading}
					variant="destructive"
					size="sm"
					disabled={deleteDisabled}
					onClick={onDelete}
					data-testid="environment-delete"
				/>
			</section>
		</div>
	);
}
